exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-body-main[data-v-79ba9546]{position:relative}.modal-body-main .batch-tips[data-v-79ba9546]{padding:0 15px}.modal-body-main .tips-error[data-v-79ba9546]{color:#f20}", ""]);

// exports
